// removed by extract-text-webpack-plugin
module.exports = {"container":"YSqaxdb3nPQ_1hZYeW_kz","main":"_33yVNdqVzbQGSe_YHtT9oZ","sidebar":"_1wE6cYJ7kwZyaeTJlNJYud","media":"_7SAddawYnx_9tXmf7V8Si"};


//////////////////
// WEBPACK FOOTER
// ../components/Content/style.module.less
// module id = 932
// module chunks = 0